export default __webpack_public_path__ + "static/media/viamo.0e38381b.svg";